/**
 * Routes list
 * BPM Monitor API Routes
 */
const _prefix = String(process.env.API_PREFIX_BPM_SUPERVISOR || '/bpm/v1/supervisor')
const _prefix2 = String(process.env.API_PREFIX_BPM_EXECUTOR || '/bpm/v1/executor')

export default {
  //
  // Supervisor Monitor.
  //
  monitor: {
    summary: _prefix + "/summary",
    processes: _prefix + "/processes",
    process: _prefix + "/processes/{process_id}",

    // Подробная информация (включая данные портов) об одном Процессе для Монитора Исполнителя
    data: _prefix2 + "/processes/{process_id}/extra_data",

    contractors: {
      index:  _prefix + "/processes/{process_id}/contractors",
      dismiss:  _prefix + "/processes/{process_id}/contractors/dismiss",
      assign:  _prefix + "/processes/{process_id}/contractors/{contractor_id}/assign",
    },

    actions: {
      cancel:  _prefix + "/processes/{process_id}/cancel",
      hold:  _prefix + "/processes/{process_id}/hold",
      resume:  _prefix + "/processes/{process_id}/resume",
    }
  },

  //
  // Monitor Filters.
  //
  filter: {
    index: _prefix + "/filters",
    show: _prefix + "/filters/{filter_code}",
  }
}



// WEBPACK FOOTER //
// ./src/apps/bpm/superMonitor/api/routes.js